import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import SyncConstants from "../../constants/SyncConstants";
import { copy } from "../../libs/SlotUtils";
import PersonLabelWithDynamicInfo from "../Team/PersonLabelWithDynamicInfo";
import MinutesToTime from "./MinutesToTime";

const ConfirmButton = (props) => {
    const [firstClick, setFirstClick] = useState(false);

    return (
        <>
            {!firstClick ? (
                <button
                    onClick={e => setFirstClick(true)}
                    className={props.className}
                    title="Löschen"
                >
                    {props.label}
                </button>
            ) : (
                <div className="btn-group btn-group-sm">
                    <button
                        onClick={e => { props.onConfirm(); setFirstClick(false) }}
                        className="btn btn-danger btn-sm"
                        title="Bestätigen"
                    >
                        {props.labelConfirm}
                    </button>
                    <button
                        onClick={e => setFirstClick(false)}
                        className="btn btn-outline-secondary btn-sm"
                        title="Abbrechen"
                    >
                        <i className="bi bi-x-lg"></i>
                    </button>
                </div>
            )}
        </>
    )
}  

export default ConfirmButton;